import { OptionResource, VariantResource } from "../types";

export const getDefaultVariant = (option: OptionResource): VariantResource | undefined => {
    const variants = option.variants;
    if (!variants) {
        return;
    }
    if (variants.length === 1) {
        return variants[0];
    }
    if (option.defaultVariant === undefined) {
        return;
    }
    return variants.find((variant) => variant.id === option.defaultVariant);
};
